import $ from "jquery";
/* eslint-disable */
export default function menu() {
  $(".mm-image:first-child").addClass("active");
  if ($(window).width() > 1096) {
    $("#mmenusnowboard .mm-link").mouseenter(function () {
      var cat_id = $(this).attr("data-attr");
      var attr_id = $("#mmenusnowboard .mm-link.active").attr("data-attr");
      $("#mmenusnowboard .mm-link").removeClass("active");
      $("#mmenusnowboard #mmlink-" + cat_id).addClass("active");
      if (attr_id != cat_id) {
        $("#mmenusnowboard .mm-image").removeClass("active");
        $("#mmenusnowboard #mmimage-" + cat_id).addClass("active");
      }
    });

    $("#mmenuski .mm-link").mouseenter(function () {
      var cat_id = $(this).attr("data-attr");
      var attr_id = $("#mmenuski .mm-link.active").attr("data-attr");
      $("#mmenuski .mm-link").removeClass("active");
      $("#mmenuski #mmlink-" + cat_id).addClass("active");
      if (attr_id != cat_id) {
        $("#mmenuski .mm-image").removeClass("active");
        $("#mmenuski #mmimage-" + cat_id).addClass("active");
      }
    });

    $("#mmenudestinations .mm-link").mouseenter(function () {
      var cat_id = $(this).attr("data-attr");
      var attr_id = $("#mmenudestinations .mm-link.active").attr("data-attr");
      $("#mmenudestinations .mm-link").removeClass("active");
      $("#mmenudestinations #mmlink-" + cat_id).addClass("active");
      if (attr_id != cat_id) {
        $("#mmenudestinations .mm-image").removeClass("active");
        $("#mmenudestinations #mmimage-" + cat_id).addClass("active");
      }
    });

    $(".menu-ski").attr("id", "mmski");

    $(".menu-snowboard").attr("id", "mmsnow");

    $(".menu-destinations").attr("id", "mmdestinations");

    var menuArr = { mmenu: false, mmski: false, mmsnow: false, mmdestinations };

    $(".menu-ski").mouseenter(function () {
      menuArr[$("#mmsnow").attr("id")] = false;
      menuArr[$(this).attr("id")] = true;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenusnowboard").fadeOut();
          $("#mmenudestinations").fadeOut();
          $("#mmenuski").fadeIn();
        }
      }, 300);
    });

    $(".menu-snowboard").mouseenter(function () {
      menuArr[$("#mmski").attr("id")] = false;
      menuArr[$(this).attr("id")] = true;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenuski").fadeOut();
          $("#mmenudestinations").fadeOut();
          $("#mmenusnowboard").fadeIn();
        }
      }, 300);
    });

    $(".menu-destinations").mouseenter(function () {
      menuArr[$("#mmdestinations").attr("id")] = false;
      menuArr[$(this).attr("id")] = true;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenuski").fadeOut();
          $("#mmenusnowboard").fadeOut();
          $("#mmenudestinations").fadeIn();
        }
      }, 300);
    });

    $(".menu-ski").mouseleave(function () {
      menuArr.mmski = false;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenuski").fadeOut();
        }
      }, 300);
    });

    $(".menu-snowboard").mouseleave(function () {
      menuArr.mmsnow = false;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenusnowboard").fadeOut();
        }
      }, 300);
    });

    $(".menu-destinations").mouseleave(function () {
      menuArr.mmdestinations = false;
      setTimeout(function () {
        if (!menuArr.mmenu) {
          $("#mmenudestinations").fadeOut();
        }
      }, 300);
    });

    $(".mega-menu").mouseenter(function () {
      menuArr.mmenu = true;
    });

    $(".mega-menu").mouseleave(function () {
      menuArr.mmski = false;
      menuArr.mmsnow = false;
      menuArr.mmdestinations = false;
      menuArr.mmenu = false;
      setTimeout(function () {
        if (
          !menuArr.mmsnowboard &&
          !menuArr.mmski &&
          !menuArr.mmdestinations &&
          !menuArr.mmenu
        ) {
          $(".mega-menu").fadeOut();
        }
      }, 300);
    });
  }

  if ($(window).width() < 1096) {
    $(".responsive-navigation .menu-item-has-children").on(
      "click",
      function () {
        $(this).toggleClass("is-open");
      }
    );
    $(".js-mobile-nav").on("click", function () {
      $("body").toggleClass("disable-scroll");
      $(".js-responsive-nav-container").toggleClass("hidden");
      $(this).toggleClass("is-open");
    });
  }
}
